export default __webpack_public_path__ + "static/media/logo-darkblue.273f30cb.svg";